import { render } from "./CountryPage.vue?vue&type=template&id=2dd0f6a1&scoped=true"
import script from "./CountryPage.vue?vue&type=script&lang=js"
export * from "./CountryPage.vue?vue&type=script&lang=js"

import "./CountryPage.vue?vue&type=style&index=0&id=2dd0f6a1&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd0f6a1"]])

export default __exports__